var render = function render(_c,_vm){return _c('div',{staticClass:"video-player-full-text",domProps:{"innerHTML":_vm._s(_vm.props.fullText)}})
}
var staticRenderFns = []

export { render, staticRenderFns }